import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, reduxForm, change } from 'redux-form';
import { Button, FormControl } from 'react-bootstrap';
import cx from 'classnames';

import DateRange from '../DateRange/DateRange';
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import MobileDateRange from '../MobileDateRange/MobileDateRange';

import { setPersonalizedValues } from '../../../actions/personalized';
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import { searchFormSuggestSelect, changeSearchForm } from '../../../helpers/GeoSuggest/updateSearchForm';
import messages from '../../../locale/jsonMessages';
import history from '../../../core/history';

import searchIcon from '/public/SiteIcons/homeSearchIcon.svg';

import cs from '../../commonStyle.css';
import s from './VideoSearchForm.css';

function VideoSearchForm({
  personalized,
  settingsData,
  listingFields,
  setPersonalizedValues,
  change
}) {
  const [personCapacity, setPersonCapacity] = useState([]);
  const [state, setState] = useState({
    smallDevice: false,
    verySmallDevice: false
  })
  const [isLoad, setIsLoad] = useState(true);
  const intl = useIntl();


  useEffect(() => {
    if (listingFields) {
      setPersonCapacity(listingFields.personCapacity || []);
    }

    setIsLoad(false);
  }, []);

  useEffect(() => {
    if (listingFields) {
      setPersonCapacity(listingFields.personCapacity || []);
    }
  }, [listingFields]);


  const handleResize = useCallback(() => {
    const isBrowser = typeof window !== 'undefined';
    setState(prev => ({
      ...prev,
      smallDevice: isBrowser ? window.matchMedia('(max-width: 767px)').matches : true,
      verySmallDevice: isBrowser ? window.matchMedia('(max-width: 480px)').matches : false
    }));
  }, []);

  useEffect(() => {
    setState(prev => ({ ...prev, isLoad: false }));
    if (typeof window !== 'undefined') {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [handleResize]);

  const handleClick = () => {
    let uri = '/s?';

    if (personalized?.chosen != null) {
      uri += `&address=${personalized.location}&chosen=${personalized.chosen}`;
    } else if (personalized?.location != null) {
      uri += `&address=${personalized.location}`;
    }

    if (personalized?.startDate && personalized?.endDate) {
      uri += `&startDate=${personalized.startDate}&endDate=${personalized.endDate}`;
    }

    if (personalized?.personCapacity && !isNaN(personalized.personCapacity)) {
      uri += `&guests=${personalized.personCapacity}`;
    }

    history.push(encodeURI(uri));
  };

  const onSuggestSelect = (data, value) => {
    searchFormSuggestSelect({ data, setPersonalizedValues, value });
  };

  const onChangeSearch = (value) => {
    if (value === '') {
      changeSearchForm({ setPersonalizedValues, change });
    }
  };

  const renderFormControl = ({ input, label, type, meta: { touched, error }, className }) => (
    <div>
      {touched && error && <span className={s.errorMessage}>{intl.formatMessage(error)}</span>}
      <FormControl {...input} placeholder={label} type={type} className={className} />
    </div>
  );

  const renderPlacesSuggest = ({ input, label, containerClassName }) => (
    <PlaceGeoSuggest
      {...input}
      placeholder={label}
      initialValue={personalized?.location}
      containerClassName={containerClassName}
      onSuggestSelect={onSuggestSelect}
      onChange={onChangeSearch}
      id="videoSearch"
    />
  );

  return (
    <form autoComplete="off">
      <div className={cx('homeSearchForm vidSearchForm')}>
        <div className={cx(s.tableCell, s.location)}>
          <label className='commonLabelText'>
            <FormattedMessage {...messages.where} />
          </label>
          <label className={s.searchElement} aria-label="Location input">
            {
              !isLoad ? (
                <Field
                  label={intl.formatMessage(messages.homeWhere)}
                  className={cx(s.formControlInput, s.input)}
                  component={renderPlacesSuggest}
                  autoComplete="off"
                  containerClassName="layoutThreeDetailsFormGeoSuggest"
                />
              ) : (
                <Field
                  component={renderFormControl}
                  label={intl.formatMessage(messages.homeWhere)}
                  className={cx(s.formControlInput, s.input, s.loadfield)}
                  autoComplete="off"
                />
              )
            }
          </label>
        </div>
        <div className={cx(s.tableCell, s.dates)}>
          <label className='commonLabelText'>
            <span><FormattedMessage {...messages.when} /></span>
          </label>
          <span className={cx('homeDate vidFormsearch', s.input, 'searchBoxshadow')}>
            {state?.smallDevice
              ? <MobileDateRange formName="SearchForm" numberOfMonths={1} verySmallDevice={state?.verySmallDevice} />
              : <DateRange formName="SearchForm" numberOfMonths={2} />
            }
          </span>
        </div>
        <div className={cx(s.search)}>
          <Button className={cx(s.btn, s.btnPrimary, s.btnBlock)} onClick={handleClick}>
            <img src={searchIcon} className="imgIconRight" />
            <FormattedMessage {...messages.search} />
          </Button>
        </div>
      </div>
    </form>
  );
}

VideoSearchForm.propTypes = {
  setPersonalizedValues: PropTypes.any.isRequired,
  change: PropTypes.any.isRequired,
  personalized: PropTypes.object,
  settingsData: PropTypes.shape({
    listSettings: PropTypes.array.isRequired
  }),
  listingFields: PropTypes.object
};

VideoSearchForm.defaultProps = {
  personalized: {
    location: null,
    lat: null,
    lng: null,
    startDate: null,
    endDate: null,
    personCapacity: null,
    chosen: null
  },
  settingsData: {
    listSettings: []
  },
  listingFields: {}
};

const mapState = (state) => ({
  personalized: state.personalized,
  settingsData: state.viewListing.settingsData,
  listingFields: state.listingFields.data,
});

const mapDispatch = {
  setPersonalizedValues,
  change
};

export default reduxForm({
  form: 'VideoSearchForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(VideoSearchForm))));
